import { ReactNode, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { auth } from '../lib/auth'
import { navigation } from '../lib/navigation'
import LoadingSpinner from './LoadingSpinner'

interface AuthGuardProps {
  children: ReactNode
  loading?: boolean
}

const AuthGuard = ({ children, loading = false }: AuthGuardProps) => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    // If not authenticated and not on login page, store current location and redirect to login
    if (!auth.isAuthenticated() && location.pathname !== '/login') {
      navigation.setIntendedDestination(location.pathname + location.search)
      navigation.redirectToLogin(navigate)
    }
  }, [location, navigate])

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  // If not authenticated, don't render children (redirect will happen in useEffect)
  if (!auth.isAuthenticated()) {
    return null
  }

  // If authenticated, render children
  return <>{children}</>
}

export default AuthGuard



